const svg = (inner: string): string =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${inner}</svg>`;

export const ICONS = {
  close: svg(
    '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
  ),
  chevronUp: svg('<polyline points="18 15 12 9 6 15"/>'),
  chevronDown: svg('<polyline points="6 9 12 15 18 9"/>'),
  statement: svg('<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>'),
  closeBox: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="3"/><line x1="9" y1="9" x2="15" y2="15"/><line x1="15" y1="9" x2="9" y2="15"/></svg>`,
  sun: svg(
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>',
  ),
  moon: svg(
    '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>',
  ),

  // Universal Accessibility Symbol (international human figure with outstretched arms and spread legs)
  wheelchair: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="13.5 9 96 96" fill="currentColor" aria-hidden="true">
    <circle cx="61.44" cy="20.66" r="8.83"/>
    <path d="M61.05,74.18L52.1,98.91a4.94,4.94,0,0,1-2.58,2.83A5,5,0,0,1,42.7,95.5l6.24-17.28a26.3,26.3,0,0,0,1.17-4,40.64,40.64,0,0,0,.54-4.18c.24-2.53.41-5.27.54-7.9s.22-5.18.29-7.29c.09-2.63-.62-2.8-2.73-3.3l-.44-.1-18-3.39A5,5,0,0,1,27.08,46a5,5,0,0,1,5.05-7.74l19.34,3.63c.77.07,1.52.16,2.31.25a57.64,57.64,0,0,0,7.18.53A81.13,81.13,0,0,0,69.9,42c.9-.1,1.75-.21,2.6-.29l18.25-3.42A5,5,0,0,1,94.5,39a5,5,0,0,1,1.3,7,5,5,0,0,1-3.21,2.09L75.15,51.37c-.58.13-1.1.22-1.56.29-1.82.31-2.72.47-2.61,3.06.08,1.89.31,4.15.61,6.51.35,2.77.81,5.71,1.29,8.4.31,1.77.6,3.19,1,4.55s.79,2.75,1.39,4.42l6.11,16.9a5,5,0,0,1-6.82,6.24,4.94,4.94,0,0,1-2.58-2.83L63,74.23,62,72.4l-1,1.78Z"/>
  </svg>`,
  accessibility: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="13.5 9 96 96" fill="currentColor" aria-hidden="true">
    <circle cx="61.44" cy="20.66" r="8.83"/>
    <path d="M61.05,74.18L52.1,98.91a4.94,4.94,0,0,1-2.58,2.83A5,5,0,0,1,42.7,95.5l6.24-17.28a26.3,26.3,0,0,0,1.17-4,40.64,40.64,0,0,0,.54-4.18c.24-2.53.41-5.27.54-7.9s.22-5.18.29-7.29c.09-2.63-.62-2.8-2.73-3.3l-.44-.1-18-3.39A5,5,0,0,1,27.08,46a5,5,0,0,1,5.05-7.74l19.34,3.63c.77.07,1.52.16,2.31.25a57.64,57.64,0,0,0,7.18.53A81.13,81.13,0,0,0,69.9,42c.9-.1,1.75-.21,2.6-.29l18.25-3.42A5,5,0,0,1,94.5,39a5,5,0,0,1,1.3,7,5,5,0,0,1-3.21,2.09L75.15,51.37c-.58.13-1.1.22-1.56.29-1.82.31-2.72.47-2.61,3.06.08,1.89.31,4.15.61,6.51.35,2.77.81,5.71,1.29,8.4.31,1.77.6,3.19,1,4.55s.79,2.75,1.39,4.42l6.11,16.9a5,5,0,0,1-6.82,6.24,4.94,4.94,0,0,1-2.58-2.83L63,74.23,62,72.4l-1,1.78Z"/>
  </svg>`,

  // Profiles
  seizure: svg('<path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>'),
  vision: svg(
    '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z"/><circle cx="12" cy="12" r="3"/>',
  ),
  adhd: svg(
    '<circle cx="12" cy="12" r="9"/><path d="M8 12h8"/><path d="M12 8v8"/><circle cx="18" cy="5" r="2" fill="currentColor" stroke="none"/>',
  ),
  cognitive: svg(
    '<path d="M9.5 2a2.5 2.5 0 0 1 5 0v1a5 5 0 0 1 5 5v1a5 5 0 0 1-5 5h-5a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5V2z"/><path d="M9 13v5"/><path d="M15 13v5"/><path d="M7 18h10"/>',
  ),
  keyboard: svg(
    '<rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M6 14h12"/>',
  ),
  screenReader: svg(
    '<path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1v-6h3z"/><path d="M3 19a2 2 0 0 0 2 2h1v-6H3z"/>',
  ),
  colorBlind: svg(
    '<circle cx="9" cy="12" r="5"/><circle cx="15" cy="12" r="5" opacity="0.5"/>',
  ),
  dyslexia: svg(
    '<path d="M4 19V5"/><path d="M4 5h8a4 4 0 0 1 0 8H4"/><path d="M4 13h9a4 4 0 0 1 0 8H4"/>',
  ),

  // Content adjustments
  contentScaling: svg('<path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>'),
  readableFont: svg(
    '<path d="M4 7V5h16v2"/><path d="M9 5v14"/><path d="M15 5v14"/><path d="M7 19h4M13 19h4"/>',
  ),
  highlightTitles: svg('<path d="M6 4v16M18 4v16M6 12h12"/>'),
  fontSizing: svg(
    '<path d="M3 19l5-14 5 14M5 14h6"/><path d="M14 19l3-9 3 9M15.5 16h3"/>',
  ),
  textMagnifier: svg(
    '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/><path d="M9 11h4M11 9v4"/>',
  ),
  readingLens: svg(
    '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/><path d="M11 6a5 5 0 0 1 5 5" opacity=".5"/>',
  ),
  highlightLinks: svg(
    '<path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/>',
  ),
  lineHeight: svg(
    '<path d="M3 6h18M3 12h18M3 18h18"/><path d="M6 3v3M6 18v3"/>',
  ),
  letterSpacing: svg(
    '<path d="M5 18V8l3-4 3 4v10"/><path d="M14 18V8l3-4 3 4v10"/><path d="M5 14h6M14 14h6"/>',
  ),
  textAlignLeft: svg('<path d="M3 6h18M3 12h12M3 18h18"/>'),
  textAlignCenter: svg('<path d="M3 6h18M6 12h12M3 18h18"/>'),
  textAlignRight: svg('<path d="M3 6h18M9 12h12M3 18h18"/>'),

  // Color adjustments
  darkContrast: svg(
    '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>',
  ),
  lightContrast: svg(
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>',
  ),
  highContrast: svg(
    '<circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor" stroke="none"/>',
  ),
  monochrome: svg(
    '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12 2.69l5.66 5.66a8 8 0 0 1-5.66 13.65L12 2.69z" fill="currentColor" stroke="none"/>',
  ),
  highSaturation: svg(
    '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" fill="currentColor" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>',
  ),
  lowSaturation: svg(
    '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12 9l2.83 2.83a4 4 0 1 1-5.66 0z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
  ),
  invertColors: svg(
    '<path d="M12 2v20M2 12h20"/><path d="M12 2a10 10 0 0 1 0 20z" fill="currentColor" stroke="none"/>',
  ),

  // Orientation adjustments
  readingGuide: svg(
    '<rect x="3" y="4.5" width="18" height="5" rx="2.5" stroke-width="1.6"/><polygon points="10,6.5 17.5,14 13.5,14 16,19 14,20 11.5,15 9,17.5" fill="currentColor" stroke="currentColor" stroke-width="0.8" stroke-linejoin="round"/>',
  ),
  stopAnimations: svg('<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>'),
  readingMask: svg(
    '<rect x="8" y="3" width="13" height="13" rx="2"/><rect x="3" y="8" width="13" height="13" rx="2"/>',
  ),
  highlightHover: svg(
    '<line x1="4" y1="9" x2="20" y2="9" stroke-width="2"/><line x1="4" y1="15" x2="20" y2="15" stroke-width="2"/><line x1="9" y1="4" x2="9" y2="20" stroke-width="2"/><line x1="15" y1="4" x2="15" y2="20" stroke-width="2"/>',
  ),
  bigBlackCursor: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0c0c0c" stroke="#52525b" stroke-width="1.2" stroke-linejoin="round" aria-hidden="true"><path d="M14 4.5a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7.5l-1.3-1.6a2.2 2.2 0 0 0-3.3.2 2.2 2.2 0 0 0 .2 3.1l4.9 5.3A7.5 7.5 0 0 0 16 21.5h1.5a6.5 6.5 0 0 0 6.5-6.5v-3.5a2 2 0 0 0-2-2 2 2 0 0 0-2 2v-1a2 2 0 0 0-2-2 2 2 0 0 0-2 2v-1a2 2 0 0 0-2-2z"/></svg>`,
  bigWhiteCursor: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#ffffff" stroke="#0c0c0c" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M14 4.5a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7.5l-1.3-1.6a2.2 2.2 0 0 0-3.3.2 2.2 2.2 0 0 0 .2 3.1l4.9 5.3A7.5 7.5 0 0 0 16 21.5h1.5a6.5 6.5 0 0 0 6.5-6.5v-3.5a2 2 0 0 0-2-2 2 2 0 0 0-2 2v-1a2 2 0 0 0-2-2 2 2 0 0 0-2 2v-1a2 2 0 0 0-2-2z"/></svg>`,
};

export const FLAG_ICONS = {
  en: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" aria-hidden="true"><path fill="#B22234" d="M0 0h36v36H0z"/><path stroke="#fff" stroke-width="2.77" d="M0 4.15h36M0 9.7h36M0 15.2h36M0 20.8h36M0 26.3h36M0 31.8h36"/><path fill="#3C3B6E" d="M0 0h17v19.4H0z"/><path fill="#fff" d="M3 3l.7 1.4 1.5.2-1.1 1.1.3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1.1 1.5-.2zm5.5 0l.7 1.4 1.5.2-1.1 1.1.3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1.1 1.5-.2zm5.5 0l.7 1.4 1.5.2-1.1 1.1.3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1.1 1.5-.2zM5.8 7.5l.7 1.4 1.5.2-1.1 1.1.3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1.1 1.5-.2zm5.5 0l.7 1.4 1.5.2-1.1 1.1.3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1.1 1.5-.2zM3 12l.7 1.4 1.5.2-1.1 1.1.3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1.1 1.5-.2zm5.5 0l.7 1.4 1.5.2-1.1 1.1.3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1.1 1.5-.2zm5.5 0l.7 1.4 1.5.2-1.1 1.1.3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1.1 1.5-.2z"/></svg>`,
  es: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" aria-hidden="true"><path fill="#AA151B" d="M0 0h36v36H0z"/><path fill="#F1BF00" d="M0 9h36v18H0z"/><circle cx="10" cy="18" r="3.5" fill="#AA151B"/><circle cx="10" cy="18" r="2.2" fill="#F1BF00"/></svg>`,
  fr: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" aria-hidden="true"><path fill="#002654" d="M0 0h12v36H0z"/><path fill="#FFFFFF" d="M12 0h12v36H12z"/><path fill="#CE1126" d="M24 0h12v36H24z"/></svg>`,
  de: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" aria-hidden="true"><path fill="#000000" d="M0 0h36v12H0z"/><path fill="#DD0000" d="M0 12h36v12H0z"/><path fill="#FFCC00" d="M0 24h36v12H0z"/></svg>`,
  pt: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" aria-hidden="true"><path fill="#006600" d="M0 0h15v36H0z"/><path fill="#FF0000" d="M15 0h21v36H15z"/><circle cx="15" cy="18" r="5" fill="#FFCC00"/><circle cx="15" cy="18" r="3.2" fill="#FFFFFF"/><path fill="#002654" d="M13.5 16h3v4h-3z"/></svg>`,
  ar: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" aria-hidden="true"><path fill="#006C35" d="M0 0h36v36H0z"/><path fill="#FFFFFF" d="M8 15h20v2H8zm3 5h14v1H11zm-3 3l20-.8v1.2L8 24.2z"/></svg>`,
};
